<template>
    <div>
        <v-server-table ref="hseTypeTable" url="/admin/hse-types-list" :columns="columns" :options="options">

            <div slot="hse_type_id" slot-scope="props">
                <router-link :to="`/admin/hse-types-edit/${props.row.hse_type_id}`" title="Edit MIC Type" class="btn btn-sm btn-secondary">
                    <i class="fa fa-edit"></i> Edit
                </router-link>

                <router-link :to="`/admin/hse-types-delete/${props.row.hse_type_id}`" title="Delete MIC Type" class="btn btn-sm btn-danger">
                    <i class="fa fa-trash"></i> Delete
                </router-link>
            </div>

            <div slot="is_active" slot-scope="props">
                <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                <label class="badge badge-warning" v-if="props.row.is_active == 0">Inactive</label>
            </div>

            <div slot="include_in_mic_report" slot-scope="props">
                <label class="badge badge-success" v-if="props.row.include_in_mic_report == 1">Yes</label>
                <label class="badge badge-secondary" v-if="props.row.include_in_mic_report == 0">No</label>
            </div>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['hse_type_id', 'hse_type_name', 'is_active', 'include_in_mic_report'],
                options: {
                    headings: {
                        hse_type_id: 'Actions',
                        hse_type_name: 'Type Name',
                        is_active: 'Active',
                        include_in_mic_report: 'Included in MIC Report',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'hse_types.hse_type_name',
                    },
                    uniqueKey: 'hse_type_id',
                },
            }
        }
    }
</script>
